import React from "react";
import Slider from "../components/layouts/slider";
import { T } from "../components/helpful";
import { ProgressBar } from "primereact/progressbar";
import {setHomeMenu} from '../components/utilities'

/* The `Home` class component in JavaScript renders a main content section with a header, user
information, and a slider, with the ability to display a progress bar based on a downloading state. 
@author lionel ghogue ngondeke <lionelladrog@gmail.com>
*/

export default class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: "",
      slideImages: [],
      user: "",
      isDownloading:this.props.isDownloading 
    };
  }
  componentDidMount() {
    const userInfo = this.props.user;
    const sliderData = this.props.slideImages;
    const title = sliderData.title;
    setHomeMenu()
    this.setState({
      pageTitle: <T value={title} />,
      slideImages: sliderData.data,
      user: `${userInfo.userOthername} ${userInfo.userSurname}`,
    });
  }

  componentDidUpdate(prevProps) {

    if (this.props.isDownloading !== prevProps.isDownloading) {
      this.setState({
        isDownloading: this.props.isDownloading
      });
    }
  }

 
  
  render() {
    // console.log('slideImages:',this.state.slideImages);
    return (
      <div className="main-content">
        <div>
          <div>
            <div className="home-header text-capitalize">
              <div>
              <p className=" ">{this.state.pageTitle}</p>
              <h3 className="fw-semibold fs-2 pb-3 ">{this.state.user}</h3>
              </div>
              
            </div>
            {this.state.isDownloading ? (
              <ProgressBar
                mode="indeterminate"
                style={{ height: "1px" }}
                color={"#b4a064"}
                className="progress-bar-home "
              ></ProgressBar>
            ) : null}
             
          </div>
          <div className="">
            <Slider slideImages={this.state.slideImages} />
          </div>
        </div>
      </div>
    );
  }
}
